<template>
  <div class="p-4">

    <div v-if="!loaded" class="text-center py-4 text-muted">
      <i class="ri-loader-4-line"></i> Cargando...
    </div>

    <div v-else>
      <!-- Resumen -->
      <div class="row mb-4">
        <div class="col-md-4">
          <div class="stat-card p-3 border rounded text-center">
            <div class="text-muted small">Días de descanso (año actual)</div>
            <div class="font-weight-bold h4 mb-0 text-primary">{{ summary.totalDaysThisYear }}</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="stat-card p-3 border rounded text-center">
            <div class="text-muted small">Descansos activos</div>
            <div class="font-weight-bold h4 mb-0">{{ summary.activeCount }}</div>
          </div>
        </div>
        <div class="col-md-4 d-flex align-items-center justify-content-center">
          <router-link
            :to="{ name: 'medical-leave-create', query: { employeeId } }"
            class="button button-primary button-sm"
          >
            <i class="ri-heart-pulse-line mr-1"></i> Registrar descanso
          </router-link>
        </div>
      </div>

      <!-- Tabla de descansos -->
      <h5 class="mb-3">Historial de descansos médicos</h5>
      <div class="table-responsive">
        <table class="custom-table">
          <thead>
            <tr>
              <th>TIPO</th>
              <th>FECHA INICIO</th>
              <th>FECHA FIN</th>
              <th>DÍAS</th>
              <th>ESTADO</th>
              <th class="text-center">DETALLE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="leaves.length === 0">
              <td colspan="6" class="text-center text-muted py-3">No hay descansos médicos registrados</td>
            </tr>
            <tr v-for="leave in leaves" :key="leave.id">
              <td>
                <span :class="['badge', getTypeColor(leave.leaveType)]">{{ getTypeLabel(leave.leaveType) }}</span>
              </td>
              <td>{{ leave.startDate }}</td>
              <td>{{ leave.endDate }}</td>
              <td>{{ leave.calendarDays }}</td>
              <td>
                <span :class="['badge', getStatusColor(leave.status)]">{{ leave.status }}</span>
              </td>
              <td class="text-center">
                <router-link :to="{ name: 'medical-leave-detail', params: { id: leave.id } }" class="text-primary">
                  <i class="ri-eye-line"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { Alert } from 'wize-admin'
import { MedicalLeaveService } from '@/core/services'
import { Constants } from '@/core/utils'

export default {
  name: 'MedicalLeavesTab',
  props: {
    employeeId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      summary: { totalDaysThisYear: 0, activeCount: 0 },
      leaves:  [],
    }
  },
  methods: {
    getTypeColor(leaveType) {
      const found = Object.values(Constants.MedicalLeaveType).find(t => t.key === leaveType)
      return found ? found.color : 'badge-gray'
    },
    getTypeLabel(leaveType) {
      const found = Object.values(Constants.MedicalLeaveType).find(t => t.key === leaveType)
      return found ? found.label : leaveType
    },
    getStatusColor(status) {
      const found = Object.values(Constants.MedicalLeaveStatus).find(s => s.key === status)
      return found ? found.color : 'badge-gray'
    },
  },
  async mounted() {
    if (!this.employeeId) { this.loaded = true; return }
    try {
      const [summaryResp, leavesResp] = await Promise.all([
        MedicalLeaveService.getSummary(this.employeeId),
        MedicalLeaveService.getByEmployee(this.employeeId),
      ])
      this.summary = summaryResp.payload  || { totalDaysThisYear: 0, activeCount: 0 }
      this.leaves  = leavesResp.payload   || []
    } catch (e) {
      Alert.error('Error al cargar descansos médicos')
    } finally {
      this.loaded = true
    }
  },
}
</script>
